function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#141B21",
  fillRule: "nonzero",
  d: "M.877 3.4L3.733.6l9.069 9.244L3.428 19.4.572 16.6l6.626-6.756z"
});

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 20"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMTMgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYzLjEgKDkyNDUyKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5jaGV2cm9uUmlnaHQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iY2hldnJvblJpZ2h0IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cG9seWdvbiBpZD0iUGF0aCIgZmlsbD0iIzE0MUIyMSIgZmlsbC1ydWxlPSJub256ZXJvIiBwb2ludHM9IjAuODc3MjkxNDkzIDMuNDAwNTg4NiAzLjczMjcwODUxIDAuNTk5NDExNDAyIDEyLjgwMTYwMDIgOS44NDM5MDYwNCAzLjQyNzgwMjQ0IDE5LjQwMDQ5MjggMC41NzIxOTc1NTUgMTYuNTk5NTA3MiA3LjE5OCA5Ljg0NCI+PC9wb2x5Z29uPgogICAgPC9nPgo8L3N2Zz4=";
export { SvgChevronRight as ReactComponent };